import { fetcher, useFetch } from "matsuri-hooks";
import { getM2MStorageHubDomain } from "./storage/getM2MStorageHubDomain";
import { type App, apps } from "./apps-data";

export * from "./apps-data";

export const useApps = (): App[] => {
  const env =
    globalThis.M2M_COMPONENTS_ENV === "production"
      ? "production"
      : "development";
  const domain = getM2MStorageHubDomain(env);
  const { data, error } = useFetch<App[]>(`${domain}/api/apps`);
  if (error || !data) {
    return apps;
  }
  return data;
};

export const appsPromise = async (signal?: AbortSignal): Promise<App[]> => {
  const env =
    globalThis.M2M_COMPONENTS_ENV === "production"
      ? "production"
      : "development";
  const domain = getM2MStorageHubDomain(env);
  const { data, error } = await fetcher<App[]>(`${domain}/api/apps`, {
    // eslint-disable-next-line no-restricted-globals
    fetch: (info, init) => fetch(info, { ...init, signal }),
  });
  if (error || !data) {
    return apps;
  }
  return data;
};
